import { EMPLOYER_USER_ROLES } from '@cnect/user-shared'
import { DefaultCustomerRoles } from '@engineering11/customer-web'

export type AllRoles = EMPLOYER_USER_ROLES | DefaultCustomerRoles

export const ALL_ROLES: AllRoles[] = Object.values(EMPLOYER_USER_ROLES).concat(Object.values(DefaultCustomerRoles) as any) as AllRoles[]

export const RoleDescriptionMap: Record<AllRoles, string> = {
  [EMPLOYER_USER_ROLES.ADMINISTRATOR]: 'The Administrator role has access to all features including user management and billing.',
  [EMPLOYER_USER_ROLES.CONTRIBUTOR]: 'The contributor role has access to openings where they are on the decision team.',
  [EMPLOYER_USER_ROLES.INTERNAL_RECRUITER]: 'The internal recruiter role has access to all features related to openings and candidates.',
  [DefaultCustomerRoles.ClientEditor]: 'Can edit clients',
  [DefaultCustomerRoles.ClientViewer]: 'Can view clients',
  [DefaultCustomerRoles.TenantAdmin]: 'Full administrative powers for client management',
}

export const RoleLabelMap: Record<AllRoles, string> = {
  [EMPLOYER_USER_ROLES.ADMINISTRATOR]: 'Administrator',
  [EMPLOYER_USER_ROLES.CONTRIBUTOR]: 'Contributor',
  [EMPLOYER_USER_ROLES.INTERNAL_RECRUITER]: 'Internal Recruiter',
  [DefaultCustomerRoles.ClientEditor]: 'Client Editor',
  [DefaultCustomerRoles.ClientViewer]: 'Client Viewer',
  [DefaultCustomerRoles.TenantAdmin]: 'Tenant Admin',
}

export function roleToSelectOption(role: AllRoles) {
  return { label: RoleLabelMap[role], value: role, description: RoleDescriptionMap[role] }
}
